<div class="main-container d-flex justify-content-between align-items-center">

  <div class="title mt-4">
    <h1>AnimeLyfe</h1>
  </div>

<button (click)="goToList()" class="btn btn-primary">Home</button>

</div>

<hr>

  <div class="outlet-container">
    <router-outlet></router-outlet>
  </div>

